module.exports = __webpack_public_path__ + "images/Carbon_Black-c9673f.png";